export const delay = (ts: number) =>
  new Promise((resolve) => setTimeout(resolve, ts));
